import React from "react";
import moment from "moment";
import { Card, Table } from "antd";

function ViewPastUploads() {
  const columns = [
    {
      title: "Audit Universe",
      dataIndex: "auditUniverse",
      key: "auditUniverse",
    },
    {
      title: "Entity Name/Third Party Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Process Name",
      dataIndex: "processName",
      key: "processName",
    },
    {
      title: "Sub Process Name",
      dataIndex: "subProcessName",
      key: "subProcessName",
    },
    {
      title: "Uploaded On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => moment(createdAt).format("DD/MM/YYYY HH:mm:ss"),
    },
  ];
  return (
    <>
      <Card className="h-full">
        <div className="text-2xl mb-3 font-semibold">Past Uploads</div>

        <Table
          // dataSource={data}
          // loading={!data}
          columns={columns}
          rowKey="uniqueId"
          bordered={true}
          pagination={true}
          scroll={{ x: 1000 }}
        />
      </Card>
    </>
  );
}

export default ViewPastUploads;
